import { useContext } from 'react'
import { AuthModalContext } from '../contexts/AuthModalContext'

export const useAuthModal = () => {
  return useContext(AuthModalContext)
}
